import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-past-due-members',
  templateUrl: './past-due-members.component.html',
  styleUrls: ['./past-due-members.component.css']
})
export class PastDueMembersComponent implements OnInit {

  @Input() NoOfPastDueMembers: string;
  @Output() filterMembersEvent = new EventEmitter();

  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterMemberListing(value) {
    this.program_status = value;
    this.filterMembersEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/past-due-members/past-due-members.component.ts